export const Bullet = ({ property, value, label, extra, onClick }) => {
    if (!value && !extra) {
        return null;
    }

    const removeFilter = () => {
        onClick?.(property, value);
    };

    if (value) {
        if (onClick) {
            return (
                <button className="flex filter-bullet" onClick={removeFilter}>
                    <i className="fa fa-times text-danger mr5" />
                    <span>{label || value}</span>
                </button>
            );
        } else {
            return (
                <span className="flex filter-bullet">
                    <i className="fa fa-check text-success mr5" />
                    <span>{label || value}</span>
                </span>
            );
        }
    } else {
        return <span className="filter-bullet">+{extra}</span>;
    }
};

export default Bullet;
